module.exports = require("./createClass.js");


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/helpers/create-class.js
// module id = 902
// module chunks = 0